import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import Main from "./views/Main.vue";
import AdvancedListView from "./components/AdvancedListView.vue";
import FormView from "./components/FormView.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "main",
      component: Main,
      children: [
        {
          path: "/entities/:type/list/",
          name: "entities_list",
          component: AdvancedListView,
          props: true
        },
        {
          path: "/entities/:type/create/",
          name: "entity_create",
          component: FormView,
          props: true
        },
        {
          path: "entities/:type/edit/:id",
          name: "entity_edit",
          component: FormView,
          props: true
        }
      ]
    },

    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "LoginPage" */ "./components/LoginPage.vue")
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch("loadLocale");
  await store.dispatch("loadToken"); // Загружаем из базы токен
  await store.dispatch("loadUser"); // Загружем из базы данные пользователя
  next();
});

export default router;
